import React, { MouseEventHandler, useCallback, useEffect, useState } from "react";
import "./index.less";
import { Image, Popover, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import ResourceOverviewList from "./List";
import { MenuItem, ResourceListItem } from "@/types/base";
import { getFreeDownloadOverview } from "@/api/freeDownload";
import { Resource } from "@/types/resource";
import { getServiceVal } from "@/utils/cookies";

const prefix = "resource-overview";
const ResourceOverview = (props: any) => {
  const { menu } = props;
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false); //加载状态
  const [resourceOverviewInfo, setResourceOverviewInfo] = useState<Resource.ResourceOverview | null>(null); //资源预览信息
  const [resourceRecords, setResourceRecords] = useState<{ title: "resourceCount" | "resourceDetailCount"; desc: string }[]>([
    {
      title: "resourceCount",
      desc: "丰富的产品满足开发者各种场景下的需求",
    },
    {
      title: "resourceDetailCount",
      desc: "丰富的镜像包、工具和文档用于构建各种工业场景",
    },
  ]); //资源记录

  const jumpDetailClick = useCallback((id: string) => {
    console.log("headerLeftClick");
    navigate("/freedownload?resourceId=" + id);
  }, []);

  const getOverviewData = async () => {
    try {
      setLoading(true);
      const res = await getFreeDownloadOverview();
      console.log("getOverviewData", res);
      const { code, result } = res;
      if (code == 200) {
        setResourceOverviewInfo(result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      console.log("finally");
      setLoading(false);
    }
  };

  useEffect(() => {
    getOverviewData();
  }, []);
  const resourceOverviewProductTagName = getServiceVal("Authorization") ? "我的" : "热门";
  return (
    <div className={`${prefix}`}>
      <Spin spinning={loading}>
        <div className={`${prefix}-header`}>
          {resourceOverviewInfo != null &&resourceOverviewInfo.categoryId && (
          <div className={`${prefix}-header-left`} onClick={jumpDetailClick.bind(this, resourceOverviewInfo?.resourceId || "")}>
            <div className={`${prefix}-header-left-content`}>
              
                <>
                  {resourceOverviewInfo?.goodsName && (
                    <div className={`${prefix}-header-left-content-title`}>
                      <span className="flex-center">{resourceOverviewProductTagName}</span>
                      <span>{resourceOverviewInfo?.goodsName}</span>
                    </div>
                  )}
                  
                    <div className={`${prefix}-header-left-content-desc`}>
                       {resourceOverviewInfo?.toolsName &&(<div className="tool-name"><span>{resourceOverviewInfo?.toolsName}</span></div>)}
                      {resourceOverviewInfo?.documentName && (<div className="document-name"><span>{resourceOverviewInfo?.documentName}</span></div>)}
                    </div>
                  
                </>

            </div>
            
            <div className={`${prefix}-header-left-img flex-center`}>
              <Image preview={false} src={resourceOverviewInfo?.overviewImage} />
            </div>
            
          </div>
                        )}
          <div className={`${prefix}-header-right`}>
            {resourceOverviewInfo != null &&
              resourceRecords.map((item) => {
                return (
                  <div className={`${prefix}-header-right-item`} key={item.title}>
                    <div className={`${prefix}-header-right-item-title`}>{resourceOverviewInfo?.[item.title]}</div>
                    <div className={`${prefix}-header-right-item-desc two-line-ellipsis`}>{item.desc}</div>
                  </div>
                );
              })}
          </div>
        </div>
      </Spin>
      {menu != null &&
        menu.length > 0 &&
        menu.map((item: MenuItem) => {
          return <ResourceOverviewList data={item} key={item.id} />;
        })}
    </div>
  );
};

export default React.memo(ResourceOverview);
